import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { CartonProvider } from "../../shared/providers/carton.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { CartonCodesModel, CartonModel } from "../../shared/models/carton";
import { ToastClientService } from "src/app/services/toast/toast-client.service";

@Component({
  selector: 'app-carton-codes',
  templateUrl: './carton-codes.component.html',
  styleUrls: ['./carton-codes.component.scss']
})
export class CartonCodesComponent implements OnInit {

  cartonCodes: any = [];
  cartonId;
  formData: any = {};
  constructor(
    private fb: FormBuilder,
    public cartonProviders: CartonProvider,
    public adminDataProvider: AdminDataProvider,
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() { 
    this.cartonId = this.activatedRoute.snapshot.paramMap.get('id');
    this.getCartonCodes();
  }

  getCartonCodes() {
      this.apiService.get(this.apiConfig.getCartonCodes + this.cartonId).subscribe(
        (res: any) => {
          this.cartonCodes = res.data.carton_codes as CartonCodesModel[];
        },err=>{
          this.toast.Error(err.body.data.message);
        }
      );
  }

  startGenetating(){
    this.formData.program_id = 1;
    this.formData.campaign_id = this.cartonId;
    this.apiService.post(this.apiConfig.generateQRImages, this.formData)
    .subscribe((res:any)=>{
      this.toast.Success('Generating QR codes')
      setTimeout(() => {
        this.getCartonCodes();
      }, 2000);
    },err=>{
      this.toast.Error('Error Generating QR codes')
    })
  }

  openWindow(url)
  {
    window.open(url, '_blank');
  }

}
